import { t } from 'i18next';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { iconPlus } from '@/components/icons';
import { baseStyles, buttonStyles } from '@/styles';

@customElement('fg-accordion-title-button')
export class FgAccordionTitleButton extends LitElement {
  @property({ type: String })
  collapseQueryString?: string | null;

  updateComponent(queryString: string | null | undefined) {
    if (queryString === null || queryString === undefined) {
      console.error('Missing query string');
      return;
    }
    this.dispatchEvent(
      new CustomEvent('option-selected', {
        composed: true,
        detail: { option: { queryString } },
      }),
    );
  }

  render() {
    if (
      this.collapseQueryString === null ||
      this.collapseQueryString === undefined
    )
      return nothing;

    return html`
      <button
        type="button"
        class="button button-primary button-small button-icon"
        @click=${() => this.updateComponent(this.collapseQueryString)}
      >
        <span aria-hidden="true">${iconPlus}</span>
        ${t('actions.addPrintPosition')}
      </button>
    `;
  }

  static styles = [
    baseStyles,
    buttonStyles,
    css`
      button.button-icon {
        white-space: nowrap;
      }
    `,
  ];
}
